import { BrowserModule } from '@angular/platform-browser';
import { NgModule, InjectionToken, Injectable, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import { TabsComponent } from './tabs/tabs.component';
import { RouterModule, Routes, ActivatedRouteSnapshot, RunGuardsAndResolvers, NavigationEnd, RouteReuseStrategy } from '@angular/router';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpService } from './core/http/http.service';
import { ApiPrefixInterceptor } from './core/interceptors/api-prefix.interceptor';
import { HeaderSearchComponent } from './header-search/header-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationsComponent } from './notifications/notifications.component';
import { JulWebSharedLibModule } from 'jul-web-shared-lib';
import { PipesModule } from 'jul-web-shared-lib/src/lib/pipes';
import { MomentModule } from 'ngx-moment';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { BsDropdownModule} from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { NotFoundComponent } from './not-found/not-found.component';
import { ContentComponent } from './content/content.component';
import { AppRoutingModule } from './app.routing';
import { AuthGuard } from './core/guards/auth.guard';
import { filter, map } from 'rxjs/operators';
import { GlobalEventDistributor } from 'src/globalEventDistributor';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { LoadingScreenInterceptor } from './helpers/loading.interceptor';
import { BlockUITemplateComponent } from './block-ui-termplate';
import { AlertifyModule, AlertifyService } from 'jul-web-shared-lib/src/lib/components/alertify';
import { reducers, metaReducers, CustomSerializer } from './_store';
import { BlockUIModule } from 'ng-block-ui';
import { TabService } from './tabs/services/tab.service';
import { LocationStrategy, HashLocationStrategy, PathLocationStrategy, APP_BASE_HREF, CommonModule } from '@angular/common';
import { ProcessService } from './tabs/services/process-events.service';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { coreReducers } from './core/_store/reducers';
import { effects } from './core/_store/effects';
import { HeaderComponent } from './header/header.component';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import {   TranslationLoader } from './translation/custom-http-translate.loader';
import { TasksComponent } from './tasks/tasks.component';
import { NavigationTriggerComponent } from './navigation-trigger/navigation-trigger.component';
import { SharedService } from './services/shared.service';
import { LocalStorageService, SessionStorageService, SharedStorageService } from 'ngx-store';
import { ErrorModule } from './error/error.module';
const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
const deactivateGuard = new InjectionToken('deactivateGuard');
const RunsGuardsAndResolvers: RunGuardsAndResolvers = "always"
import { JulContextModule } from 'jul-web-shared-lib/src/lib/components/context';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ImpersonalizationPopupComponent } from './impersonalization-popup/impersonalization-popup.component';
import { InputModule } from 'jul-web-shared-lib/src/lib/components/input';
import { RadioButtonModule } from 'jul-web-shared-lib/src/lib/components/radio-button';
import { InfiniteScrollModule } from 'jul-web-shared-lib/src/lib/components/infinite-scroll';
import { MessageService } from './services/message.service';
import { CheckboxModule } from 'jul-web-shared-lib/src/lib/components/checkbox';
import { HourMinutePipe } from './core/pipes/hour-minute.pipe';
import { DateInterceptor } from './core/interceptors/date.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MicroFrontendRouteReuseStrategy } from './services/route-reuse-strategy';

export const bsDropdownModule = BsDropdownModule.forRoot();

export function externalRoute(route: ActivatedRouteSnapshot) {
  const externalUrl = route.paramMap.get('externalUrl');
  window.open(externalUrl, '_self');
}

export function tokenGetter(): string {
  return localStorage.getItem('token');
}
export function deactivateGuardFunction() {
  return true;
}
export const jwtModule = JwtModule.forRoot({
  config: {
    tokenGetter: tokenGetter,
    skipWhenExpired: true,
    throwNoTokenError: false,
    headerName: 'Authorization',
    authScheme: 'Bearer ',
    // Para desenvolvimento nao esta na white List 'access-control.ptecports.com'
    whitelistedDomains: ['jul-dev.ptecports.com', 'jul-dev-md.ptecports.com', 'jul-dev-md.local.ptecports.com',
      'jul-qa.ptecports.com', 'jul-qa-md.ptecports.com', 'jul-qa-md.local.ptecports.com',
      'jul-masterdata-qa-md.ptecports.com', 'jul-masterdata-qa-md.local.ptecports.com',
      'jul-gn-qa-md.ptecports.com', 'jul-gn-qa-md.local.ptecports.com', 'jul-pp.ptecports.com',
      'jul-pp.local.ptecports.com', 'jul-pp-md.ptecports.com', 'jul-pp-md.local.ptecports.com',
      'gad-pp-md.ptecports.com', 'gad-pp-md.local.ptecports.com', 'jul-masterdata-pp-md.ptecports.com',
      'jul-masterdata-pp-md.local.ptecports.com', 'jul-gn-pp-md.ptecports.com', 'jul-gn-pp-md.local.ptecports.com',
      'jul-notifier-qa-md.ptecports.com', 'jul-notifier-pp-md.ptecports.com',
      'access-control.ptecports.com', 'localhost:8080', 'localhost:4200'] // TODO parametrize this
  }
});

export function TranslationLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const julContextModule = JulContextModule.forRoot('NATIONAL');
export const modalModule = ModalModule.forRoot();
@NgModule({
  entryComponents:[
    BlockUITemplateComponent,
    ImpersonalizationPopupComponent
  ],
  declarations: [
    AppComponent,
    TabsComponent,
    HeaderMenuComponent,
    NavigationTriggerComponent,
    HeaderSearchComponent,
    NotificationsComponent,
    NotFoundComponent,
    ContentComponent,
    LoadingScreenComponent,
    BlockUITemplateComponent,
    HeaderComponent,
    TasksComponent,
    ImpersonalizationPopupComponent,
    HourMinutePipe,
  ],
  imports: [
    julContextModule,
    modalModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    RadioButtonModule,
    CheckboxModule,
    ErrorModule,
    MomentModule,
    AlertifyModule,
    BrowserAnimationsModule,
    StoreModule.forFeature('core', coreReducers),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    EffectsModule.forRoot(effects),
    // RouterModule.forRoot(routes),
    NgxExtendedPdfViewerModule,
    PerfectScrollbarModule,
    PipesModule,
    AppRoutingModule,
    CommonModule,
    InfiniteScrollModule,
    BsDropdownModule.forRoot(),
    InputModule,
    ReactiveFormsModule,
    JulWebSharedLibModule,
    jwtModule,
    bsDropdownModule,
    TooltipModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationLoader,
        deps: [HttpClient]
      }
    }),
    BlockUIModule.forRoot({
      delayStart: 50,
      delayStop: 200,

      template: BlockUITemplateComponent,
    }),
  ],
  providers: [
    SharedService,
    LocalStorageService,
    SessionStorageService,
    SharedStorageService,
    MessageService,
    BsModalService,
    AlertifyService,
    {
      provide: HttpClient,
      useClass: HttpService
    },
    {
      provide: externalUrlProvider,
      useValue: externalRoute
    },
    TabService,
    ProcessService,
    {
      provide: deactivateGuard,
      useValue: deactivateGuardFunction
    },
    {
      provide: RouteReuseStrategy,
      useClass: MicroFrontendRouteReuseStrategy,
    },
    {
      provide: GlobalEventDistributor,
      useClass: GlobalEventDistributor
    },
    ApiPrefixInterceptor,
    DateInterceptor
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private translate: TranslateService
  ) {
    translate.setDefaultLang('pt');
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.languageCode){
      translate.use(user.languageCode);
    } else {
      translate.use('pt');
    }
  }
}



